// Persists the ID of an in-flight VIP/Crush order to localStorage so
// BuyVIPPage/BuyCrushPage can resume tracking it after the Mini App is
// closed and reopened — closing the WebView to switch to a banking app to
// scan the QR (the whole point of a QRIS payment) previously lost the order
// id entirely, since it lived only in React component state. See
// BuyVIPPage.tsx/BuyCrushPage.tsx's mount-time resume check.
export type PendingOrderKind = 'vip' | 'crush'

function storageKey(kind: PendingOrderKind): string {
  return `swipify:pending_${kind}_order`
}

export function savePendingOrder(kind: PendingOrderKind, orderID: number): void {
  try {
    localStorage.setItem(storageKey(kind), String(orderID))
  } catch {
    // Storage unavailable (private mode, quota) — resume just won't work
    // for this order; the purchase flow itself is unaffected.
  }
}

export function getPendingOrder(kind: PendingOrderKind): number | null {
  try {
    const raw = localStorage.getItem(storageKey(kind))
    if (!raw) return null
    const id = Number(raw)
    return Number.isFinite(id) ? id : null
  } catch {
    return null
  }
}

export function clearPendingOrder(kind: PendingOrderKind): void {
  try {
    localStorage.removeItem(storageKey(kind))
  } catch {
    // Nothing to do — see savePendingOrder.
  }
}
